import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServicesModule } from 'src/app/services/services.module';
import { PipesModule } from '../../pipes/pipes.module';
import { DirectivesModule } from '../../directives/directives.module';
import { SharedComponent } from './shared.component';
import { SHARED_ROUTES } from './shared.routes';
import { SharedModule } from 'src/app/components/shared/shared.module';
import { NoPageFoundComponent } from './no-page-found/no-page-found.component';

@NgModule({
  imports: [
    SHARED_ROUTES, 
    CommonModule, 
    ServicesModule, 
    PipesModule, 
    SharedModule, 
    DirectivesModule
  ],
  declarations: [SharedComponent, NoPageFoundComponent,],
})
export class SharedPagesModule {}